import { z } from 'zod';
import { validationMessagesMap } from 'src/utils/messages'; /**/

export const webhookEndpointFormSchema = z.object({
    url: z.url({ message: validationMessagesMap.validationErrorURL }).nonempty(),
    description: z.string().optional(),
    is_active: z.boolean().nullable(),
    topics: z.array(z.string()).nonempty(),
});
export type WebhookEndpointSchemaValues = z.infer<typeof webhookEndpointFormSchema>;

export type PatchWebhookEndpointSchemaValues = z.infer<typeof patchWebhookEndpointFormSchema>;
export const patchWebhookEndpointFormSchema = webhookEndpointFormSchema.partial();
